import React from "react";
import { Sparkles, Loader2 } from "lucide-react";
import Field from "@/components/post-ad/Field";
import { POST } from "@/constants/testIds";

/**
 * Category picker + "auto-pick category" affordance. The AI suggestion
 * uses the current keywords/title/description to slot the ad into the
 * closest node without forcing the user through the two-step chooser.
 */
export default function CategorySection({
  categorySlug,
  categories,
  onChange,
  suggestCatMut,
  canSuggest,
}) {
  return (
    <Field label="Category *">
      <div className="flex gap-2 items-stretch">
        <select
          data-testid={POST.category}
          value={categorySlug}
          onChange={(e) => onChange(e.target.value)}
          required
          className="input flex-1"
        >
          <option value="">Select a category</option>
          {categories.map((c) => (
            <optgroup key={c.id} label={c.name}>
              <option value={c.slug}>{c.name}</option>
              {(c.children || []).map((sc) => (
                <option key={sc.id} value={sc.slug}>&nbsp;&nbsp;{sc.name}</option>
              ))}
            </optgroup>
          ))}
        </select>
        <button
          type="button"
          onClick={() => suggestCatMut.mutate()}
          disabled={suggestCatMut.isPending || !canSuggest}
          data-testid="post-ad-ai-suggest-category"
          title="Auto-pick category"
          className="rounded-full bg-white border border-[color:var(--brand-blue)] text-[color:var(--brand-blue)] hover:bg-[color:var(--brand-blue-wash)] font-bold px-4 disabled:opacity-60 transition-colors"
        >
          {suggestCatMut.isPending ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <Sparkles className="w-4 h-4" />
          )}
        </button>
      </div>
    </Field>
  );
}
